import React, { useRef, useState, useEffect } from "react";
import {
  Popover,
  Overlay,
  ListGroup,
  Lis,
  OverlayTrigger,
  Button,
} from "react-bootstrap";
import { i18n } from "@lingui/core";
import { useCookies } from "react-cookie";
import { useMediaQuery } from "react-responsive";

import Image from "next/image";
import { UserIcon } from "../../Icon";
const User = (props) => {
  const { loading, error, data } = props;
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef();

  const [, , removeCookie] = useCookies();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isDesktop = useMediaQuery({ maxWidth: 1200 });
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };
  const handleClose = () => {};
  const handleLogout = () => {
    removeCookie("access_token", {
      domain: process.env.REACT_APP_BASE_DOMAIN,
      path: "/",
    });
    window.open(`${process.env.REACT_APP_NEW_DOMAIN}login`, "_self");
  };

  // document.getElementsByClassName("over").clickOutsideThisElement(function(){
  //   setShow(!show)
  // })

  if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error...</div>

  // useEffect(()=>{
  //   document.body.addEventListener("click", function (evt) {
  //     if(show===true){
  //       setShow(false);
  //     }

  //   });
  // },[show])
  return (
    <div className="  mt-3">
      <OverlayTrigger
        placement="bottom"
        trigger="click"
        key="bottom"
        rootClose
        overlay={
          <Popover id="popover-contained">
            <Popover.Body className="popover-body">
              <ListGroup>
                <ListGroup.Item
                  action
                  href={`${process.env.REACT_APP_DOMAIN}myprofile`}
                >
                  <div className="text-center">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      fill="currentColor"
                      className="bi bi-person-circle "
                      viewBox="0 0 16 16"
                    >
                      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                      <path
                        fill-rule="evenodd"
                        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                      />
                    </svg>
                  </div>
                  <div className="text-center ">{data?.me.name}</div>
                  <div className="text-center">Lihat Profile anda</div>
                </ListGroup.Item>

                <ListGroup.Item>
                  <div className="d-flex justify-content-between">
                    <span className="text-start">Saldo Cashback</span>
                    <span text-align="text-end">
                      {i18n.number(data?.me.cashback, {
                        style: "currency",
                        currency: "IDR",
                        minimumFractionDigits: 0,
                      })}
                    </span>
                  </div>
                </ListGroup.Item>

                <ListGroup.Item
                  action
                  href={`${process.env.REACT_APP_DOMAIN}controlpanel/dashboard`}
                >
                  <div className="align-items-center text-start justify-content-start">
                    <span className="icon-equalizer pe-2"></span>Control Panel
                  </div>
                </ListGroup.Item>

                <ListGroup.Item action onClick={handleLogout}>
                  <div className="align-items-center text-start justify-content-start">
                    <span className="icon-switch pe-2"></span>Logout
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Popover.Body>
          </Popover>
        }
      >
        {loading ? (
          <>
            <div>
              <span>Loading...</span>
            </div>
          </>
        ) : (
          <div>
            <div classsName="btn" onClick={handleClick}>
              <p className="text-center ">
                {" "}
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  fill="currentColor"
                  class="bi bi-person-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path
                    fill-rule="evenodd"
                    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                  />
                </svg> */}
                <UserIcon className="text-light " width="30" height="30" />
                {/* <img src="profile-user.svg" width="60px" height="60px" className="btn"/> */}
                {/* <Image src="/profile-user.svg" width={25} height={25} className="btn"/> */}
                <span
                  className={`text-light fw-bold text-capitalize ps-2 btn ${
                    isMobile ? "d-none" : null
                  }`}
                >
                  {data?.me.name}
                </span>
              </p>
            </div>
          </div>
        )}
      </OverlayTrigger>
    </div>
  );
};

export default User;
